import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { AppShell, Page } from "@/components/layout/AppShell";
import Home, { Live, Search } from "@/pages/Home";
import Login, { Register, AuthCallback } from "@/pages/Auth";
import ReaderProfile, { PostPage } from "@/pages/ReaderProfile";
import ServicePage from "@/pages/ServicePage";
import ReadingRoom from "@/pages/ReadingRoom";
import TablePage from "@/pages/TablePage";
import Market, { ProductPage, CartPage, PaymentResult, PaymentCancel } from "@/pages/Market";
import You, { Inbox, Notifications } from "@/pages/You";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Suspended from "@/pages/Suspended";
import Community, { ThreadPage } from "@/pages/Community";

const Legal = () => (
  <Page className="max-w-2xl prose">
    <h1 className="text-4xl font-semibold mb-4">Terms & Community Standards</h1>
    <p className="text-sm text-[#2C2A28] leading-relaxed">Shufflar is an 18+ platform for readers, creators and community. Readings and spiritual content are offered for reflection and entertainment and are not a substitute for professional medical, legal, or financial advice. Readers and creators are independent sellers; Shufflar facilitates payment, holds funds until delivery, and applies a platform commission set by the operator. All sales are final. Private reading artifacts are retained until you delete them and are accessible only to the reader and client involved.</p>
  </Page>
);

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/live" element={<Live />} />
        <Route path="/search" element={<Search />} />
        <Route path="/market" element={<Market />} />
        <Route path="/community" element={<Community />} />
        <Route path="/community/:id" element={<ThreadPage />} />
        <Route path="/products/:id" element={<ProductPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/inbox/:id" element={<Inbox />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/you" element={<You />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/suspended" element={<Suspended />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/moderation" element={<Admin forceTab="moderation" />} />
        <Route path="/table" element={<TablePage />} />
        <Route path="/services/:id" element={<ServicePage />} />
        <Route path="/readings/:id" element={<ReadingRoom />} />
        <Route path="/posts/:id" element={<PostPage />} />
        <Route path="/legal/:slug" element={<Legal />} />
        <Route path="/:username" element={<ReaderProfile />} />
      </Routes>
    </AppShell>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Router />
            <Toaster position="top-center" toastOptions={{ style: { background: "#1A1917", color: "#F6F4EE", border: "1px solid #2A2825", fontFamily: "Plus Jakarta Sans" } }} />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}
